// extracted by mini-css-extract-plugin
module.exports = {"container_s":"styles_container_s__ck0_l","about_info__title":"styles_about_info__title__ycaF8","wrapper_description":"styles_wrapper_description__q38SX"};